import { Link } from "react-router-dom";
import { CHARACTERS } from "@/data/mellow";

export default function MellowFriends() {
  return (
    <div className="max-w-7xl mx-auto px-6 lg:px-10 py-14">
      <div className="mb-10">
        <p className="font-cursive text-2xl text-[#78353A]/70">Sous cette marque se cachent</p>
        <h1 className="font-cursive text-6xl md:text-7xl text-[#78353A] leading-none">Les MellowFriends</h1>
        <p className="mt-4 max-w-xl text-[#4A3B32]/85 leading-relaxed">Six petites âmes, six univers, six manières de rêver. Choisis un personnage pour découvrir son histoire et ses articles.</p>
      </div>
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {CHARACTERS.map((c) => (
          <Link
            key={c.slug}
            to={`/personnages/${c.slug}`}
            className="group relative rounded-3xl border-2 border-dashed border-[#D1D5CB] p-6 hover:-translate-y-1 transition-transform"
            style={{ background: c.bg }}
            data-testid={`friend-card-${c.slug}`}
          >
            <div className="relative aspect-square rounded-2xl overflow-hidden bg-[#FAF9F6]/60 mb-4">
              {c.portrait ? (
                <img src={c.portrait} alt={c.name} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
              ) : (
                <div className="w-full h-full flex items-center justify-center">
                  <span className="daisy-deco" style={{ width: 90, height: 90 }}></span>
                </div>
              )}
            </div>
            <h3 className="font-cursive text-4xl text-[#78353A] leading-none">{c.name} <span className="text-2xl text-[#4A3B32]/70">{c.species}</span></h3>
            <p className="mt-2 text-sm text-[#4A3B32]/80">{c.tagline}</p>
            <p className="mt-4 font-cursive text-2xl text-[#4A3B32] group-hover:text-[#78353A]">Découvrir →</p>
          </Link>
        ))}
      </div>
    </div>
  );
}
